import { MutableRefObject, createContext } from 'react';

export type KeyboardShortcutsState = {
  [key: string]: MutableRefObject<() => void>;
};

const defaultState: KeyboardShortcutsState = {};

export const KeyboardShortcutsContext = createContext(defaultState);
